import { useState, useEffect } from "react";
import { orderService } from "services";

export const useOrders = (userId) => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!userId) {
      setOrders([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    const unsubscribe = orderService.subscribeToUserOrders(userId, (data) => {
      setOrders(data);
      setLoading(false);
    });

    return unsubscribe;
  }, [userId]);

  return { orders, loading, error };
};
